import styled from "styled-components";
import Row from "react-bootstrap/Row";
import mapa from "../../assets/Colombia 2.png"
import fondo from "../../assets/numbers.png"


export const StyledWrapperAbout = styled(Row)`
  margin-top: 95px;
  .card-body {
    font-size: 12px;
    padding-left: 5px;
    padding-top: 3px;
    padding-bottom: 3px;
    .names {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
    }
    .names p{
      margin-bottom: 0px;
      font-size: 15px;
    }
    .irlink {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      button {
        margin-left: 7px;
        border: none;
        background: #e63457;
        padding: 9px 12px;
        font-size: 12px;
        text-align: left;
        a {
          color: #000;
          font-size: 12px;
          font-weight: bold;
          display: block;
        }
        svg {
          margin-left: 4px;
          color: #fff;
        }
      }
    }
  }
  .card-header p::before {
    display: inline-block;
    color: #E63457;
    content: "+";
    width: 5px;
    margin: 0 8px 0 0;
}
  .card-header {
    background-color: transparent !important;
    padding-left: 0px !important;
    padding-top: 0px !important;
    border-bottom: none !important;
    cursor: pointer;

    p {
      margin-top: 16px;
      text-align: left;
      font-size: 16px;
      line-height: 17px;
      margin-bottom: 0;
      cursor: pointer;
      &::before {
        display: inline-block;
        color: #e63457;
        content: "+";
        width: 5px;
        margin: 0 8px 0 0;
      }
      @media (max-width: 600px) {
        font-size: 18px;
      }
    }
  }

  .primercontainer {
    padding: 15px 15px;
    @media (max-width: 991px) {
      padding: 0px !important;
    }
    .golink {
      background: #354052;
      border: 1px solid #354052;
      padding: 2px;
      margin-top: 0px;
      svg {
        color: #fff;
      }
    }
    h2 {
      font-weight: bold;
      font-size: 20px;
      line-height: 24px;
      color: #000;
      margin-bottom: 46px;
      margin-top: 46px;
    }

    .text {
      font-weight: normal;
      font-size: 14px;
      line-height: 24px;
      color: #000;
    }
  }
  .numbers {
    background: url("https://storage.googleapis.com/pj-chequeado-publico/landings/latamchequea/2022/img-portada.jpg") no-repeat;
    background-size: cover;
    background-position: center;
    color: #fff;
    padding: 0;
    a {
      color: white
    }
    a:hover {
      color: white
    }
    .number {
      font-weight: bold;
      font-size: 100px;
      line-height: 122px;
      text-align: center;
      margin-bottom: 0px;
    }
    @media (max-width: 768px) {
      padding: 50px 15px;
    }
  }
  .ubicacion {
    background: url(${mapa}) no-repeat #D42B4C;
    padding: 50px 60px;
    height: 100%;
    width: 100%;
    text-align: center;
    background-position: center;

    .info {
      margin-top: 20px;
      color: white;
      font-size: 100px;
      line-height: 90px;
      margin-bottom: 120px;

      @media (max-width: 1024px) {
        font-size: 60px;
        line-height: 69px;
      }
      @media (max-width: 991px) {
        font-size: 100px;
        line-height: 90px;
        margin-bottom: 55px;
      }
    }
  }
  .inscribirse{
    color: #000000;
  }
`;
